// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 14 13"
    {...props}
  >
    <path
      fill="#6421B9"
      d="M6.64 12.672C6.4 11.296 5.424 9.568 3.568 8.176C2.656 7.488 1.728 7.04 0.816 6.848V6.176C2.624 5.744 4.4 4.528 5.536 2.88C6.112 2.048 6.48 1.232 6.64 0.384H7.312C7.584 2 8.832 3.792 10.528 4.992C11.36 5.584 12.224 5.984 13.104 6.176V6.848C11.328 7.216 9.264 8.8 8.24 10.416C7.728 11.232 7.424 11.984 7.312 12.672H6.64Z"
    />
  </svg>
);
const IconAiStar = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconAiStar;
